/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Survey_NoInputs */

const sv_page_survey_no = /** @type {(inputs: Page_Survey_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej`)
};

const en_page_survey_no = /** @type {(inputs: Page_Survey_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Page_Survey_NoInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_survey_no = /** @type {((inputs?: Page_Survey_NoInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Survey_NoInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_survey_no(inputs)
	return en_page_survey_no(inputs)
});